import { defineProperty as _defineProperty, inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, detectBrowser, Reveal, getMarginBottomClass, Heading, UnorderedList, ListItem, VisuallyHidden, Link } from '@piggybank/core';
import { connect } from 'formik';
import kebabCase from 'lodash/fp/kebabCase';
import isEqual from 'lodash/fp/isEqual';
import countBy from 'lodash/fp/countBy';
import { scroller } from 'react-scroll';
import getNestedValues from '../../utils/getNestedValues.js';
import styles from './form-feedback.css.js'; // Test the user agent for iOS and then focus the heading instead.

var countByValue = countBy(function (_ref) {
  var value = _ref.value;
  return value;
});

var FormFeedback = /*#__PURE__*/function (_Component) {
  _inherits(FormFeedback, _Component);

  function FormFeedback(props) {
    var _this;

    _classCallCheck(this, FormFeedback);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormFeedback).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event, _ref2) {
      var path = _ref2.path;
      event.preventDefault();
      var fieldId = kebabCase("field-".concat(path));
      var fieldEl = document.getElementById(fieldId);
      if (!fieldEl) return;
      scroller.scrollTo(fieldId, {
        duration: 500,
        offset: -72,
        smooth: 'easeInOutCubic'
      });
      _this.scrollTimeout = setTimeout(function () {
        var inputEl = fieldEl.querySelector('input,select,textarea');
        if (inputEl) inputEl.focus();
      }, 1);
    });

    _this.state = {
      submitCount: 0,
      errorMessages: []
    };
    _this.ref = React.createRef();
    return _this;
  }

  _createClass(FormFeedback, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!this.props.formik.isSubmitting && !this.props.formik.isValidating && !this.props.formik.isValid && this.state.submitCount > prevState.submitCount) {
        this.scrollTimeout = setTimeout(function () {
          scroller.scrollTo(_this2.props.id, {
            duration: 500,
            offset: -72,
            smooth: 'easeInOutCubic'
          });
          _this2.scrollTimeout = setTimeout(function () {
            _this2.ref.current.focus();
          }, 1);
        }, 1);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.scrollTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          id = _this$props.id,
          formik = _this$props.formik,
          textMap = _this$props.textMap,
          marginBottom = _this$props.marginBottom,
          rest = _objectWithoutProperties(_this$props, ["id", "formik", "textMap", "marginBottom"]);

      var _this$state = this.state,
          submitCount = _this$state.submitCount,
          errorMessages = _this$state.errorMessages;
      var errorMessageCounts = countByValue(errorMessages);
      var errorMessageLoopCounts = {};
      var currentErrorMessages = getNestedValues(formik.errors);
      var show = submitCount > 0 && !!errorMessages.length;
      return React.createElement("div", _extends({
        className: styles.FormFeedback,
        id: id,
        ref: !detectBrowser.iOS ? this.ref : null,
        tabIndex: "-1",
        "aria-hidden": show ? null : true
      }, rest), React.createElement(Reveal, null, show && React.createElement("div", {
        className: cn(styles.container, getMarginBottomClass(marginBottom))
      }, React.createElement(Heading, {
        level: 2,
        ref: detectBrowser.iOS ? this.ref : null,
        marginBottom: 2
      }, textMap.title), React.createElement(UnorderedList, {
        marginBottom: 0
      }, errorMessages.map(function (error) {
        var complete = !currentErrorMessages.some(isEqual(error));
        var messageIndex;

        if (errorMessageCounts[error.value] > 1) {
          if (!errorMessageLoopCounts[error.value]) {
            errorMessageLoopCounts[error.value] = 0;
          }

          messageIndex = ++errorMessageLoopCounts[error.value];
        }

        var message = React.createElement(React.Fragment, null, error.value, messageIndex && " ".concat(messageIndex, " ").concat(textMap.of, " ").concat(errorMessageCounts[error.value], " "));
        return React.createElement(ListItem, {
          key: error.path
        }, complete ? React.createElement(React.Fragment, null, React.createElement(VisuallyHidden, null, "Resolved: "), React.createElement("span", {
          className: styles.complete
        }, message)) : React.createElement(Link, {
          href: "#".concat(kebabCase("field-".concat(error.path))),
          onClick: function onClick(e) {
            _this3.handleClick(e, error);
          }
        }, message));
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!props.formik.isSubmitting && !props.formik.isValidating && props.formik.submitCount > state.submitCount) {
        if (props.formik.isValid) {
          return {
            submitCount: props.formik.submitCount
          };
        } else {
          return {
            submitCount: props.formik.submitCount,
            errorMessages: getNestedValues(props.formik.errors)
          };
        }
      }

      return null;
    }
  }]);

  return FormFeedback;
}(Component);

_defineProperty(FormFeedback, "defaultProps", {
  id: 'form-feedback',
  marginBottom: 5,
  formik: {},
  textMap: {
    title: 'Please correct the following:',
    of: ' of '
  }
});

FormFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  textMap: PropTypes.shape({
    title: PropTypes.node,
    of: PropTypes.node
  }),

  /** docgen-from-context:<Form/> */
  formik: PropTypes.shape({
    isValid: PropTypes.bool,
    isValidating: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    submitCount: PropTypes.number,
    errors: PropTypes.object
  }).isRequired,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
var connected = connect(FormFeedback);
connected.displayName = 'FormFeedback';
export default connected;
export { FormFeedback };